import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/project-settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/project-settings/general' });
  },
});
